module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "landing-page pa-4"
  }, [_c('div', {
    staticClass: "header-container ma-4"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "logo-and-menu"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/ys_logo_primary-black.svg",
      "aspect-ratio": "1",
      "height": "24",
      "width": "124"
    },
    on: {
      "click": function($event) {
        _vm.navigateTo('/')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "links-container white--text font-space-grotesk font-weight-700 text-18"
  }, [_c('span', {
    staticClass: "menu-item cursor-pointer",
    class: {
      'active-menu': _vm.isUpgrade
    },
    on: {
      "click": function($event) {
        _vm.isUpgrade = true
      }
    }
  }, [_vm._v("\n              Upgrade\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "menu-item cursor-pointer",
    on: {
      "click": function($event) {
        _vm.navigateTo('/for-creators')
      }
    }
  }, [_vm._v("\n              Creators\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "menu-item cursor-pointer",
    on: {
      "click": function($event) {
        _vm.navigateTo('/login')
      }
    }
  }, [_vm._v("\n              Signin\n            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [(!_vm.isUpgrade) ? _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-around": "",
      "row": "",
      "gap-8": ""
    }
  }, [_c('div', {
    staticClass: "blurb-container"
  }, [_c('div', {
    staticClass: "text-container white--text font-space-grotesk font-weight-500"
  }, [_c('span', {
    staticClass: "text-50"
  }, [_vm._v("\n              Music Streaming "), _c('br'), _vm._v("\n              Reinvented.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "app-icons-container"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "mt-4": "",
      "pt-4": ""
    }
  }, [_c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/apple-store.svg",
      "aspect-ratio": "1",
      "height": "54",
      "width": "187"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/google-play.svg",
      "aspect-ratio": "1",
      "height": "54",
      "width": "187"
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/ys-landing-ios.png",
      "aspect-ratio": "1",
      "height": "805",
      "width": "452"
    }
  })])])]) : _c('UpgradePlan', {
    staticClass: "pa-5",
    attrs: {
      "category-plan": _vm.categoryPlan
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fqa bg-grey-white"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "text-40 font-space-grotesk font-weight-500 fqa__title w-100 pb-4 mb-3 text-center"
  }, [_vm._v("\n        FAQ\n      ")]), _vm._v(" "), (_vm.categoryPlan == 'creator') ? _c('div', _vm._l((_vm.creatorFaqs), function(faq, index) {
    return _c('div', {
      key: index,
      staticClass: "bg-white fqa__wrapper w-100 font-dm-sans mb-4"
    }, [_c('div', {
      class: [
        'text-22 font-weight-700 text-grey-purple cursor-pointer',
        faq.open ? 'mb-4' : 'mb-2'
      ],
      on: {
        "click": function($event) {
          _vm.toggleFaq(index, 'creator')
        }
      }
    }, [_vm._v("\n            " + _vm._s(faq.question) + "\n          ")]), _vm._v(" "), (faq.open) ? _c('div', {
      staticClass: "text-18 font-weight-500"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(faq.answer)
      }
    })]) : _vm._e()])
  })) : _c('div', _vm._l((_vm.generalFaqs), function(faq, index) {
    return _c('div', {
      key: index,
      staticClass: "bg-white fqa__wrapper w-100 font-dm-sans mb-4"
    }, [_c('div', {
      class: [
        'text-22 font-weight-700 text-grey-purple cursor-pointer',
        faq.open ? 'mb-4' : 'mb-2'
      ],
      on: {
        "click": function($event) {
          _vm.toggleFaq(index, 'general')
        }
      }
    }, [_vm._v("\n            " + _vm._s(faq.question) + "\n          ")]), _vm._v(" "), (faq.open) ? _c('div', {
      staticClass: "text-18 font-weight-500"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(faq.answer)
      }
    })]) : _vm._e()])
  }))])], 1), _vm._v(" "), _c('FooterLandingPage')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72fc2972","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landing-new/components/ForCreators.vue
// module id = 1774
// module chunks = 180